module.exports = __webpack_public_path__ + "static/media/rebirth_sample_8.f62221de.jpg";